import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

import {
  OperationType,
  OperationTypeCreationData,
  OperationTypeUpdateData,
} from "../models/operation-type";

@Injectable({
  providedIn: "root",
})
export class OperationTypeService {
  public constructor(private readonly httpClient: HttpClient) {}

  public getAll(): Promise<OperationType[]> {
    return this.httpClient
      .get<
        OperationType[]
      >(`${environment.webApiUrl}/api/operationtypes`, { withCredentials: true })
      .toPromise();
  }

  public existsOperationType(
    operationType: string,
    currentOperationTypeId: string,
  ): Promise<boolean> {
    const url =
      `${environment.webApiUrl}/api/operationtypes/exists?operationTypeName=${operationType}` +
      (currentOperationTypeId
        ? `&currentOperationTypeId=${currentOperationTypeId}`
        : ``);
    return this.httpClient
      .get<boolean>(url, { withCredentials: true })
      .toPromise();
  }

  public getReportingOptions() {
    return this.httpClient
      .get<
        OperationType[]
      >(`${environment.webApiUrl}/api/operationtypes/reporting`, { withCredentials: true })
      .toPromise();
  }

  public getAccountReportingOptions(accountId: string) {
    return this.httpClient
      .get<
        OperationType[]
      >(`${environment.webApiUrl}/api/operationtypes/accountoperationtype/${accountId}`, { withCredentials: false })
      .toPromise();
  }

  public create(creationData: OperationTypeCreationData) {
    return this.httpClient
      .post<void>(`${environment.webApiUrl}/api/operationtypes`, creationData, {
        withCredentials: true,
      })
      .toPromise();
  }

  public remove(id: string) {
    return this.httpClient
      .delete<void>(`${environment.webApiUrl}/api/operationtypes/${id}`, {
        withCredentials: true,
      })
      .toPromise();
  }

  public update(updateData: OperationTypeUpdateData) {
    return this.httpClient
      .put<void>(`${environment.webApiUrl}/api/operationtypes`, updateData, {
        withCredentials: true,
      })
      .toPromise();
  }
}
